/**
 * InquiryListContainer
 * --
 */
import React from 'react';
import { useUserStack } from 'store';
import InquiryList from 'routes/admin.routes/admin.inquiry/InquiryList';
import InquiryListPresenter from './InquiryListPresenter';

const InquiryListContainer = () => {
  /* ===== ROUTE ===== */
  const userInfo = useUserStack();
  /* ===== STATE ===== */
  /* ===== VARIABLE ===== */
  /* ===== FUNCTION ===== */
  /* ===== HOOKS ===== */
  /* ===== RENDER ===== */
  return (
    <>
      {userInfo && (
        <InquiryList
          permission={userInfo.type}
          defaultShopId={userInfo.shop_information_id}
        />
      )}
    </>
  );
};

export default InquiryListContainer;
